/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import React from 'react';
import { useGlobalState } from 'src/core/hooks/useGlobalState';
import { ProgressTrackerStore } from 'src/core/stores/ProgressTrackerStore';
import { CustomTextVerificationDocumentStore } from 'src/customText/core/stores/CustomTextVerificationDocumentStore';

export const useFetchDocuments = (pageItems: CustomTextVerificationDocumentStore[]) => {
    const { dispatcher } = useGlobalState();
    const isLoadingTrackers: ProgressTrackerStore[] = [];

    React.useEffect(() => {
        pageItems.forEach(pageItem => {
            /**
             * Ensures that the document store is not fetched.
             */
            if (pageItem.isInitialized) {
                return;
            }

            /**
             * Fetches document text.
             */
            const documentFetchingTracker = new ProgressTrackerStore();

            isLoadingTrackers.push(documentFetchingTracker);

            dispatcher.dispatch('fetchDocumentContentByName', {
                documentName: pageItem.name,
                localStore: pageItem,
                tracker: documentFetchingTracker,
                toastData: {}
            });
        });
    }, [pageItems]);

    return { isLoading: isLoadingTrackers.length > 0 && isLoadingTrackers.reduce((acc, item) => acc && item.isRunning, true) };
};
